import React, { Component } from 'react';
import _ from 'lodash';
import Select from 'react-select';
import TimeSelect from './TimeSelect';
import TimezoneSelect from './TimezoneSelect';
import Alert from './Alert';
import { Link } from 'react-router-dom';
import BP_METHODS from './BPMethods';

const Api = require('./Config');

// Be sure to include styles at some point, probably during your bootstrapping
const box = {
  boxShadow: '0 4px 10px 0 rgba(0, 0, 0, .5)',
  marginBottom: '30px',
  marginTop: '30px',
  padding: '50px 80px',
};
const title = { fontSize: '24px', fontWeight: '500', marginBottom: '30px' };
const actions = { marginTop: '40px' };
const container = { margin: '20px 0 100px 0' };

const all_bp_methods = [{
      name: BP_METHODS.normal,
      value: 'normal'
      },{
      name: BP_METHODS.bp_cuff,
      value: 'bp_cuff'

      },{
      name: BP_METHODS.bp_ai,
      value: 'bp_ai'
      }]

  
 const bp_methods_no_face= all_bp_methods.filter((a) => a.value !== 'bp_ai');     

export default class CreateNewDoctor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      apps: [],
      selected_club: null,
      doctor_user_name: '',
      doctor_password: '',
      doctor_remark: '',
      phone_number: '',
      fax: '',
      loading: false,
      title: '',
      password_help: '',
      default_bp_method:'normal',
      weight_required_default: false,
      hl7_match_2_required: false,
      npi_format_required: false,
      notification_time: Api.DEFAULT_NOTIFICATION_TIME,
      notification_timezone: Api.DEFAULT_NOTIFICATION_TIMEZONE,
      allow_facial_scan: false,
      bp_methods:bp_methods_no_face,
    };
  }


   



  getApps() {
    Api.getApps(true)
      .then((apps) => {
        apps = _.map(apps, (a, b) => {
          a.clubname = unescape(a.clubname);
          return a;
        });

        this.setState({
          apps,
          doctor_password: '',
          password_help: '',
          doctor_user_name: '',
        });
        console.log(apps);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  doSubmit() {
    if (this.state.doctor_user_name.length <= 4) {
      this.alert.open('Error', 'username should be more than 4 letter');
      return;
    }
    if (this.state.doctor_password.length <= 4) {
      this.alert.open('Error', 'password should be more than 4 letter');
      return;
    }
    if (this.state.title.length <= 0) {
      this.alert.open('Error', 'Office Name is required');
      return;
    }
    if (this.state.selected_club == null) {
      this.alert.open('Error', 'please select club');
      return;
    }
    let time = this.state.notification_time;
    let timezone = this.state.notification_timezone;
    if (
      this.state.notification_time == Api.DEFAULT_NOTIFICATION_TIME &&
      this.state.notification_timezone == Api.DEFAULT_NOTIFICATION_TIMEZONE
    ) {
      time = '';
      timezone = '';
    }
    Api.saveADoctor(
      this.state.doctor_user_name,
      this.state.doctor_password,
      this.state.selected_club.club_id,
      this.state.doctor_remark,
      this.state.phone_number,
      this.state.fax,
      this.state.title,
      this.state.password_help,
      this.state.default_bp_method,
      this.state.allow_facial_scan,
      this.state.hl7_match_2_required,
      this.state.npi_format_required,
      this.state.weight_required_default,
      time,
      timezone
    )
      .then((resp) => {
        if (resp.SUCCESS == 'YES') {
          this.alert.open('SUCCESS', 'Provider created successfully.');
          this.getApps();
          this.setState({
            selected_club: null,
            doctor_user_name: '',
            doctor_password: '',
            doctor_remark: '',
            phone_number: '',
            notification_time: '',
            notification_timezone: '',
            fax: '',
            title: '',
            loading: false,
          });
          if (resp.DOC_ID) {
            this.props.history.push('/editDoctor/' + resp.DOC_ID);
          }
        } else {
          this.alert.open('Error', resp.REASON);
          this.setState({
            loading: false,
          });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          loading: false,
        });
        this.alert.open('Error', `${err}`);
      });
  }

  componentDidMount() {
    this.getApps();
  }

  itemSelected(obj) {
    this.setState({
      selected_club: obj,
    });
  }

  render() {
    return (
      <div>
        <div className="row" style={container}>
          <div className="col-md-8 col-md-offset-2" style={box}>
            <div style={title}>Add Office</div>
            <div className="content">
              <div className="form-group">
                <label> App ID: </label>{' '}
                <Select
                  onChange={(obj) => {
                    this.itemSelected(obj);
                  }}
                  value={this.state.selected_club}
                  getOptionValue={(a) => a.club_id}
                  getOptionLabel={(a) => a.clubname}
                  options={this.state.apps}
                />
              </div>

              <div className="form-group">
                <label> Ofc Username: </label>
                <input
                  type="text"
                  value={this.state.doctor_user_name}
                  onChange={(e) => {
                    this.setState({
                      doctor_user_name: e.target.value,
                    });
                  }}
                  placeholder="Username"
                  className="form-control"
                />
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label> Ofc Password: </label>{' '}
                    <input
                      value={this.state.doctor_password}
                      autoComplete="new-password"
                      name={`dd${new Date().getTime()}`}
                      onChange={(e) => {
                        this.setState({
                          doctor_password: e.target.value,
                          password_help: e.target.value,
                        });
                      }}
                      type="password"
                      placeholder=""
                      className="form-control"
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Password Hint: </label>{' '}
                    <input
                      autoComplete={false}
                      value={this.state.password_help}
                      onChange={(e) => {
                        this.setState({
                          password_help: e.target.value,
                        });
                      }}
                      type="text"
                      placeholder=""
                      className="form-control"
                    />
                  </div>
                </div>
              </div>

              <div className="form-group">
                <label> Ofc Name: </label>
                <input
                  value={this.state.title}
                  onChange={(e) => {
                    this.setState({
                      title: e.target.value,
                    });
                  }}
                  type="text"
                  placeholder="Name"
                  className="form-control"
                />
              </div>

              <div className="form-group">
                <label> Ofc Phone number: </label>
                <input
                  value={this.state.phone_number}
                  onChange={(e) => {
                    this.setState({
                      phone_number: e.target.value,
                    });
                  }}
                  type="text"
                  placeholder="Phone number"
                  className="form-control"
                />
              </div>

              <div className="form-group">
                <label> Ofc Fax: </label>{' '}
                <input
                  value={this.state.fax}
                  onChange={(e) => {
                    this.setState({
                      fax: e.target.value,
                    });
                  }}
                  type="text"
                  placeholder="Fax"
                  className="form-control"
                />
              </div>

              <div className="form-group">
                <label> Ofc Remark: </label>{' '}
                <input
                  value={this.state.doctor_remark}
                  onChange={(e) => {
                    this.setState({
                      doctor_remark: e.target.value,
                    });
                  }}
                  type="text"
                  placeholder="Remark"
                  className="form-control"
                />
              </div>
         

                     <div className="form-group" style={{ padding: 10  }}>
                <div className="checkbox">
                  <label>
                    <input
                      type="checkbox"
                      checked={this.state.allow_facial_scan}
                      onChange={(e) => {
                        this.setState({
                          allow_facial_scan: e.target.checked,
                        });
                        if(e.target.checked){
                          this.setState({
                            bp_methods: all_bp_methods,
                            default_bp_method: 'bp_ai',
                          });
                        }else{
                          this.setState({
                            bp_methods: bp_methods_no_face,
                            default_bp_method: 'normal',
                          });
                        } 



                      }}  
                   
                    
              
                    />
                    Allow Facial scan
                  </label>
                </div>
              </div>


       
           

       <div className="form-group" style={{ padding: 10, backgroundColor: '#c7eaf2' }}>
                <label>Default BP Method</label>
               <div style={{ width: '240px' }}>
                  <select
                  className='form-control'
                
                  value={this.state.default_bp_method}
                 
                  onChange={(e) => {
                   
                    this.setState({
                      default_bp_method: e.target.value,
                    });
                  }}
               
                >
                 {
                    this.state.bp_methods.map((a) => {
                      return (
                        <option key={a.value} value={a.value}>
                          {a.name}
                        </option>
                      );
                    })
                  }
                  
                  </select>
                </div>
                
              </div>

              <div className="form-group" style={{ padding: 10, backgroundColor: '#c7eaf2' }}>
                <div className="checkbox">
                  <label>
                    <input
                      type="checkbox"
                      checked={this.state.weight_required_default}
                      onChange={(e) => {
                        this.setState({
                          weight_required_default: e.target.checked,
                        });
                      }}
                    />
                    Request for Weight on HTN Journeys
                  </label>
                </div>
              </div>
              <div className="form-group" style={{ padding: 10 }}>
                <div className="checkbox">
                  <label>
                    <input
                      type="checkbox"
                      checked={this.state.hl7_match_2_required}
                      onChange={(e) => {
                        this.setState({
                          hl7_match_2_required: e.target.checked,
                        });
                      }}
                    />
                    Require 2nd matching value to HL7 files
                  </label>
                </div>
              </div>
              <div className="form-group" style={{ padding: 10 }}>
                <div className="checkbox">
                  <label>
                    <input
                      type="checkbox"
                      checked={this.state.npi_format_required}
                      onChange={(e) => {
                        this.setState({
                          npi_format_required: e.target.checked,
                        });
                      }}
                    />
                    Require NPI Format
                  </label>
                </div>
              </div>
              <div style={title}>
                <h3 style={{ paddingTop: 25 }}>Set Notification Time</h3>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <TimeSelect
                      selectedTime={this.state.notification_time}
                      startTime="06:00"
                      endTime="20:00"
                      interval={1}
                      period="hours"
                      handleChange={(value) => {
                        this.setState({
                          notification_time: value,
                        });
                      }}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <TimezoneSelect
                      selectedTimezone={this.state.notification_timezone}
                      handleChange={(value) => {
                        this.setState({
                          notification_timezone: value,
                        });
                      }}
                    />
                  </div>
                </div>
              </div>
              <div style={actions}>
                <button
                  disabled={this.state.loading}
                  onClick={() => {
                    this.doSubmit();
                  }}
                  className="btn btn-primary col-xs-4 col-xs-offset-3"
                >
                  {' '}
                  Save{' '}
                </button>
                <Link style={{ marginLeft: '10px' }} className="btn btn-default" to="/RegisterDoctor">
                  Cancel
                </Link>
              </div>
            </div>
          </div>
        </div>{' '}
        <Alert
          ref={(a) => {
            this.alert = a;
          }}
        />{' '}
      </div>
    );
  }
}
